import { render, staticRenderFns } from "./ResetPasswordLogBody.vue?vue&type=template&id=02957cfa&scoped=true&"
import script from "./ResetPasswordLogBody.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordLogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02957cfa",
  null
  
)

export default component.exports